import { format } from 'date-fns';
import { DataListItem } from '@brighte/form-components';
import { IdentificationType } from '@brighte/validation';
import { useApplicationData } from '@provider';
import { IDENTIFICATION, LABELS, formatAddress, formatDate } from '@utils';

function useIdentificationSummary(): Array<{ title: string; items: DataListItem[] | [] }> | [] {
  const identification = useApplicationData('Identification');

  if (!identification) return [];
  const {
    identification: { type, passport, drivingLicense, medicare, photoId },
    address,
    dateOfBirth,
  } = identification.applicant;

  const { DATE_OF_BIRTH, HOME_ADDRESS, SUMMARY_HEADER, IDENTIFICATION: IDENTIFICATION_LABEL } = LABELS;

  let identificationValue = '';
  const identificationType = IDENTIFICATION.IDENTIFICATION_OPTIONS.find(option => option.value === type)?.label ?? '';

  switch (type) {
    case IdentificationType.PASSPORT:
      identificationValue = `${identificationType} ${passport?.number}`;
      break;
    case IdentificationType.DRIVING_LICENSE:
      identificationValue = `${drivingLicense?.state} ${identificationType} ${drivingLicense?.number}`;
      break;
    case IdentificationType.MEDICARE:
      identificationValue = `${medicare?.color} ${identificationType} ${medicare?.number}`;
      break;
    case IdentificationType.PHOTO_ID:
      identificationValue = `${photoId?.state} ${identificationType} ${photoId?.number}`;
      break;
    default:
      break;
  }

  const identificationSummary = [
    {
      title: SUMMARY_HEADER,
      // A DataList item with no value renders as a full-width standalone statement, which is right for
      // the disclaimers elsewhere but reads as a stray heading here. Every row in this summary is a
      // term/value pair, so drop any row we have no value for.
      items: [
        {
          label: IDENTIFICATION_LABEL,
          value: identificationValue,
        },
        {
          label: DATE_OF_BIRTH,
          value: dateOfBirth instanceof Date ? format(dateOfBirth, 'dd/MM/yyyy') : formatDate(dateOfBirth),
        },
        {
          label: HOME_ADDRESS,
          value: address ? formatAddress(address) : '',
        },
      ].filter(({ value }) => !!value),
    },
  ];

  return identificationSummary;
}

export { useIdentificationSummary };
